import { motion } from 'framer-motion';
import { cloneElement, forwardRef, useCallback, useState } from 'react';
import styled from 'styled-components';
import type { ButtonProps } from '../styles';

export const RotatingButton = forwardRef<HTMLButtonElement, { children: React.ReactElement<ButtonProps> }>(
  ({ children }, ref) => {
    const [rotation, setRotation] = useState(0);
    const handleClick: ButtonProps['onClick'] = useCallback(
      (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (children.props.onClick) {
          children.props.onClick(e);
        }
        setRotation(prev => prev + 180);
      },
      [children.props]
    );

    return (
      <RotatingButtonStyled
        onClick={() => setRotation(prev => prev + 180)}
        animate={{ rotate: rotation }}
        transition={{ duration: 0.4 }}
      >
        {cloneElement(children as React.ReactElement, { ...children.props, onClick: handleClick, ref })}
      </RotatingButtonStyled>
    );
  }
);

const RotatingButtonStyled = styled(motion.div)``;
